import { combineReducers } from 'redux';
import {
  authorizedLoyaltyReducer,
  authorizedReducer,
  authorizedVplusReducer,
  userReducer
} from 'store/reducers/userReducer';
import { progressReducer } from 'store/reducers/progressReducer';
import { languageReducer } from 'store/reducers/languageReducer';
import { ekycReducer } from './ekycReducer';
import { qrCodeReducer } from './qrCodeReducer';
import { deviceReducer } from 'store/reducers/deviceReducer';

export const rootReducer = combineReducers({
  user: userReducer,
  progressReducer,
  authorizedReducer,
  authorizedVplusReducer,
  authorizedLoyaltyReducer,
  language: languageReducer,
  ekycReducer,
  qrCodeReducer,
  deviceReducer,
});
